module.exports = __webpack_public_path__ + "img/corrupted_ancient_of_war_small.5d44bdc1.png";